// Machine-assisted concept-only layout strings; NOT approved for patient distribution.
export const ADDITIONAL_LATIN_PRINT_LABELS = Object.freeze({
  "ro": {
    "whatMayHappen": "Ce se poate întâmpla",
    "whyItMayHappen": "De ce se poate întâmpla",
    "whatTeamIsDoing": "Ce face echipa dumneavoastră de îngrijire",
    "variationNote": "Acest lucru poate varia",
    "nextSteps": "Ce se poate întâmpla în continuare",
    "professionalClothes": "De obicei poartă haine profesionale, nu o uniformă standard.",
    "wearsColourGarment": "De obicei poartă {garment} de culoare {colour}.",
    "wearsGarment": "De obicei poartă {garment}.",
    "genericGarment": "îmbrăcăminte medicală",
    "preparationChecklist": "Lista mea de pregătire",
    "understandingReminder": "Urmați instrucțiunile echipei spitalului dumneavoastră. Dacă ceva nu este clar, întrebați echipa de îngrijire.",
    "whatYouMightHear": "Ce ați putea auzi",
    "whatItMeans": "Ce înseamnă:",
    "questionsToConsider": "Întrebări pe care le-ați putea adresa",
    "peopleYouMayMeet": "Persoane pe care le-ați putea întâlni",
    "clothes": "Îmbrăcăminte:",
    "officialHospitalInformation": "Informații utile de la spital",
    "localHospital": "Spitalul local",
    "forLocalReview": "Pentru revizuire de către spital",
    "evaluationDraft": "Versiune preliminară pentru evaluare",
    "prepared": "Pregătit la data de",
    "coverReminder": "Acest ghid oferă informații pentru pregătire. Urmați întotdeauna recomandările echipei spitalului dumneavoastră.",
    "stage": "Etapa",
    "of": "din",
    "yourCareTeam": "Echipa dumneavoastră de îngrijire",
    "questionsAndNotes": "Întrebări și notițe",
    "questionsToAskMyTeam": "Întrebări pentru echipa mea",
    "writingPrompt": "Notați aici orice doriți să întrebați echipa spitalului.",
    "spaceForQuestions": "Spațiu pentru întrebări",
    "notesToRemember": "Lucruri de reținut",
    "notesPrompt": "Folosiți acest spațiu pentru date, instrucțiuni sau alte notițe.",
    "spaceForNotes": "Spațiu pentru notițe",
    "importantInformation": "Informații importante",
    "pleaseRemember": "Vă rugăm să rețineți",
    "askForExplanation": "Dacă ceva nu este clar, cereți explicații echipei spitalului dumneavoastră.",
    "footerAdvice": "Verificați recomandările cu echipa spitalului dumneavoastră."
  },
  "pt": {
    "whatMayHappen": "O que pode acontecer",
    "whyItMayHappen": "Porque é que isto pode acontecer",
    "whatTeamIsDoing": "O que a sua equipa de cuidados está a fazer",
    "variationNote": "Isto pode variar",
    "nextSteps": "O que pode acontecer a seguir",
    "professionalClothes": "Normalmente usa roupa profissional em vez de um uniforme padrão.",
    "wearsColourGarment": "Normalmente usa {garment} de cor {colour}.",
    "wearsGarment": "Normalmente usa {garment}.",
    "genericGarment": "vestuário clínico",
    "preparationChecklist": "Lista de preparação",
    "understandingReminder": "Siga as instruções da equipa do seu hospital. Se algo não estiver claro, pergunte à sua equipa de cuidados.",
    "whatYouMightHear": "O que poderá ouvir",
    "whatItMeans": "O que significa:",
    "questionsToConsider": "Perguntas que poderá querer fazer",
    "peopleYouMayMeet": "Profissionais que poderá conhecer",
    "clothes": "Vestuário:",
    "officialHospitalInformation": "Informações úteis do hospital",
    "localHospital": "Hospital local",
    "forLocalReview": "Para revisão pelo hospital",
    "evaluationDraft": "Versão preliminar para avaliação",
    "prepared": "Preparado em",
    "coverReminder": "Este guia destina-se a informar e ajudar na preparação. Siga sempre as orientações da equipa do seu hospital.",
    "stage": "Etapa",
    "of": "de",
    "yourCareTeam": "A sua equipa de cuidados",
    "questionsAndNotes": "Perguntas e notas",
    "questionsToAskMyTeam": "Perguntas para a minha equipa",
    "writingPrompt": "Anote o que gostaria de perguntar à equipa do hospital.",
    "spaceForQuestions": "Espaço para perguntas",
    "notesToRemember": "Notas a recordar",
    "notesPrompt": "Use este espaço para datas, instruções ou outras notas.",
    "spaceForNotes": "Espaço para notas",
    "importantInformation": "Informações importantes",
    "pleaseRemember": "Lembre-se",
    "askForExplanation": "Se algo não estiver claro, peça à equipa do hospital que explique.",
    "footerAdvice": "Confirme as orientações com a equipa do seu hospital."
  },
  "it": {
    "whatMayHappen": "Cosa potrebbe succedere",
    "whyItMayHappen": "Perché potrebbe succedere",
    "whatTeamIsDoing": "Cosa sta facendo la sua équipe assistenziale",
    "variationNote": "Questo può variare",
    "nextSteps": "Cosa potrebbe succedere dopo",
    "professionalClothes": "Di solito indossa abiti professionali anziché un'uniforme standard.",
    "wearsColourGarment": "Di solito indossa {garment} di colore {colour}.",
    "wearsGarment": "Di solito indossa {garment}.",
    "genericGarment": "abbigliamento sanitario",
    "preparationChecklist": "Lista di preparazione",
    "understandingReminder": "Segua le istruzioni del personale del suo ospedale. Se qualcosa non è chiaro, chieda alla sua équipe assistenziale.",
    "whatYouMightHear": "Cosa potrebbe sentire",
    "whatItMeans": "Cosa significa:",
    "questionsToConsider": "Domande che potrebbe voler fare",
    "peopleYouMayMeet": "Persone che potrebbe incontrare",
    "clothes": "Abbigliamento:",
    "officialHospitalInformation": "Informazioni utili dell'ospedale",
    "localHospital": "Ospedale locale",
    "forLocalReview": "Per la revisione da parte dell'ospedale",
    "evaluationDraft": "Bozza per valutazione",
    "prepared": "Preparato il",
    "coverReminder": "Questa guida è pensata per informare e aiutare nella preparazione. Segua sempre le indicazioni del personale del suo ospedale.",
    "stage": "Fase",
    "of": "di",
    "yourCareTeam": "La sua équipe assistenziale",
    "questionsAndNotes": "Domande e appunti",
    "questionsToAskMyTeam": "Domande per la mia équipe",
    "writingPrompt": "Annoti ciò che desidera chiedere al personale dell'ospedale.",
    "spaceForQuestions": "Spazio per le domande",
    "notesToRemember": "Appunti da ricordare",
    "notesPrompt": "Usi questo spazio per date, istruzioni o altri appunti.",
    "spaceForNotes": "Spazio per gli appunti",
    "importantInformation": "Informazioni importanti",
    "pleaseRemember": "Si ricordi",
    "askForExplanation": "Se qualcosa non è chiaro, chieda al personale dell'ospedale di spiegarlo.",
    "footerAdvice": "Confermi le indicazioni con il personale del suo ospedale."
  },
  "tr": {
    "whatMayHappen": "Neler olabilir",
    "whyItMayHappen": "Bu neden olabilir",
    "whatTeamIsDoing": "Sağlık ekibiniz neler yapıyor",
    "variationNote": "Bu durum değişebilir",
    "nextSteps": "Bundan sonra neler olabilir",
    "professionalClothes": "Genellikle standart bir üniforma yerine mesleki kıyafetler giyer.",
    "wearsColourGarment": "Genellikle {colour} renkli {garment} giyer.",
    "wearsGarment": "Genellikle {garment} giyer.",
    "genericGarment": "sağlık çalışanı kıyafeti",
    "preparationChecklist": "Hazırlık kontrol listesi",
    "understandingReminder": "Kendi hastane ekibinizin talimatlarına uyun. Anlamadığınız bir şey varsa sağlık ekibinize sorun.",
    "whatYouMightHear": "Neler duyabilirsiniz",
    "whatItMeans": "Anlamı:",
    "questionsToConsider": "Sormak isteyebileceğiniz sorular",
    "peopleYouMayMeet": "Karşılaşabileceğiniz kişiler",
    "clothes": "Kıyafet:",
    "officialHospitalInformation": "Hastaneden faydalı bilgiler",
    "localHospital": "Yerel hastane",
    "forLocalReview": "Hastanenin incelemesi için",
    "evaluationDraft": "Değerlendirme taslağı",
    "prepared": "Hazırlanma tarihi",
    "coverReminder": "Bu rehber bilgilendirme ve hazırlık amaçlıdır. Her zaman kendi hastane ekibinizin önerilerine uyun.",
    "stage": "Aşama",
    "of": "/",
    "yourCareTeam": "Sağlık ekibiniz",
    "questionsAndNotes": "Sorular ve notlar",
    "questionsToAskMyTeam": "Ekibime soracağım sorular",
    "writingPrompt": "Hastane ekibinize sormak istediklerinizi buraya yazın.",
    "spaceForQuestions": "Sorular için alan",
    "notesToRemember": "Hatırlanacak notlar",
    "notesPrompt": "Bu alanı tarihler, talimatlar veya diğer notlar için kullanın.",
    "spaceForNotes": "Notlar için alan",
    "importantInformation": "Önemli bilgiler",
    "pleaseRemember": "Lütfen unutmayın",
    "askForExplanation": "Anlamadığınız bir şey varsa hastane ekibinizden açıklamasını isteyin.",
    "footerAdvice": "Önerileri kendi hastane ekibinizle teyit edin."
  },
  "tl": {
    "whatMayHappen": "Ano ang maaaring mangyari",
    "whyItMayHappen": "Bakit ito maaaring mangyari",
    "whatTeamIsDoing": "Ano ang ginagawa ng inyong pangkat ng pangangalaga",
    "variationNote": "Maaaring mag-iba ito",
    "nextSteps": "Ano ang maaaring mangyari pagkatapos",
    "professionalClothes": "Karaniwang nagsusuot ng propesyonal na damit sa halip na karaniwang uniporme.",
    "wearsColourGarment": "Karaniwang nagsusuot ng {garment} na kulay {colour}.",
    "wearsGarment": "Karaniwang nagsusuot ng {garment}.",
    "genericGarment": "damit ng kawani sa kalusugan",
    "preparationChecklist": "Listahan ng paghahanda",
    "understandingReminder": "Sundin ang mga tagubilin ng inyong pangkat sa ospital. Kung may hindi malinaw, magtanong sa inyong pangkat ng pangangalaga.",
    "whatYouMightHear": "Mga salitang maaaring marinig",
    "whatItMeans": "Ang ibig sabihin:",
    "questionsToConsider": "Mga tanong na maaaring nais ninyong itanong",
    "peopleYouMayMeet": "Mga taong maaari ninyong makilala",
    "clothes": "Damit:",
    "officialHospitalInformation": "Mahalagang impormasyon mula sa ospital",
    "localHospital": "Lokal na ospital",
    "forLocalReview": "Para sa pagsusuri ng ospital",
    "evaluationDraft": "Paunang bersiyon para sa pagsusuri",
    "prepared": "Inihanda noong",
    "coverReminder": "Ang gabay na ito ay para sa impormasyon at paghahanda. Palaging sundin ang payo ng inyong pangkat sa ospital.",
    "stage": "Yugto",
    "of": "sa",
    "yourCareTeam": "Inyong pangkat ng pangangalaga",
    "questionsAndNotes": "Mga tanong at tala",
    "questionsToAskMyTeam": "Mga tanong sa aking pangkat",
    "writingPrompt": "Isulat dito ang anumang nais ninyong itanong sa inyong pangkat sa ospital.",
    "spaceForQuestions": "Espasyo para sa mga tanong",
    "notesToRemember": "Mga talang dapat tandaan",
    "notesPrompt": "Gamitin ang espasyong ito para sa mga petsa, tagubilin o iba pang tala.",
    "spaceForNotes": "Espasyo para sa mga tala",
    "importantInformation": "Mahalagang impormasyon",
    "pleaseRemember": "Pakitandaan",
    "askForExplanation": "Kung may hindi malinaw, hilingin sa inyong pangkat sa ospital na ipaliwanag ito.",
    "footerAdvice": "Tiyaking tama ang payo kasama ng inyong pangkat sa ospital."
  }
});
